import { render, staticRenderFns } from "./JobFinalizer.vue?vue&type=template&id=2908d7de&"
import script from "./JobFinalizer.vue?vue&type=script&lang=js&"
export * from "./JobFinalizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports